import { Component, OnInit } from '@angular/core';
import { ManageService } from '../service/manage.service';

@Component({
    selector: 'app-server-select',
    templateUrl: './server-select.component.html',
    styleUrl: './server-select.component.css',
    standalone: false
})
export class ServerSelectComponent{
  public selectedServer: string = '';

  constructor(public manageService: ManageService){

  }

  // Funciton trigger when user change the selected server
  onSelectChange(){
    this.manageService.selectedServers = [...this.manageService.selectedServers];
  }

  // Function that rrturn the selected server
  getSelectedServer(){
    return this.manageService.selectedServers;
  }
}
